import { IoClose } from 'react-icons/io5'
import PopupV1 from '../../Resources/PopupV1/PopupV1'
import TableV1 from '../../Resources/TableV1/TableV1'
import classes from './Popup.module.css'

export default function Popup({ setForm, form, loading1, orderProducts }) {
    const { Order, OrderSeller, Seller, OrderShipment, OrderCommission } = orderProducts
    return (
        <div className={classes.container}>
            <PopupV1 setForm={setForm} form={form} width="82vw">
                <div className={classes.close}>
                    <div className={classes.closeIcon}>
                        <p onClick={() => setForm(!form)}>
                            <IoClose size={20} />
                        </p>
                    </div>
                    <div className={classes.header}>
                        <p>Order Details</p>
                    </div>
                </div>

                <div>
                    <TableV1>
                        <thead>
                            <tr className={`${classes.tableRow}`}>
                                <th>sl</th>
                                <th>Product</th>
                                <th>Quantity</th>
                                <th>Variant</th>
                                <th>Price</th>
                                <th>Discount (%)</th>
                                <th>Discount Price</th>
                                <th>Payable Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orderProducts.OrderProduct?.length > 0 ? (
                                orderProducts.OrderProduct?.map((item, index) => {
                                    return (
                                        <tr key={index} className={classes.tableData}>
                                            <td>{index + 1}</td>
                                            <td>{item.product_name}</td>
                                            <td>{item.order_quantity}</td>
                                            <td>{item.order_variant || '--'}</td>
                                            <td>{item.product_price}</td>
                                            <td>{item.discount_percentage}%</td>
                                            <td>{item.discount_price}</td>
                                            <td>{item.final_product_price}</td>
                                        </tr>
                                    )
                                })
                            ) : (
                                <tr>
                                    <td colSpan="12" className={classes.tableNotFound}>
                                        <h2>No Data Found</h2>
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </TableV1>
                </div>

                <div className={classes.textContainer}>
                    <div className={classes.column}>
                        <p className={classes.textLine}>
                            <span>Address:</span> {OrderShipment?.detail_address}
                        </p>
                        <p className={classes.textLine}>
                            <span>Payment:</span> {Order?.payment_method}
                        </p>
                    </div>

                    <div className={classes.column}>
                        <p className={classes.textLine}>
                            <span>Order Number:</span> {Order?.order_number}
                        </p>
                        <p className={classes.textLine}>
                            <span>Total Price:</span> {Order?.payable_price} BDT
                        </p>
                    </div>
                </div>
            </PopupV1>
        </div>
    )
}
